import React from 'react'
import moment from 'moment'
import { COLORES } from '../../../config/colores'
import DemorasPorHoraEnVolcadora from '../components/histogramas/DemorasPorHoraEnVolcadora'
import DetalleDemoraPorVolcadora from '../components/histogramas/DetalleDemoraPorVolcadora'

export const COLUMNS_HISTOGRAMA_VOLCADORA = [
  {
    name: 'fecha',
    label: 'Fecha',
    options: {
      filter: true,
      sort: true,
      sticky: true,
      filterType: 'multiselect',
      customBodyRender: fecha => {
        const f = moment(fecha).format('DD-MM')
        return <>{f}</>
      },
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: 'volcadoraCamiones',
    label: 'Volcadora',
    options: {
      filter: true,
      sort: true,
      sticky: true,
      filterType: 'checkbox',
      setCellProps: () => ({
        style: {
          position: 'sticky',
          whiteSpace: 'nowrap',
          left: 0,
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: 'entry',
    label: ' ',
    options: {
      filter: false,
      sort: false,
      customBodyRender: entry => {
        const fecha = entry['fecha']
        const volcadora = entry['volcadoraCamiones']
        const filtroInicial = [
          {
            name: 'volcadoraCamiones',
            filterList: [volcadora]
          }
        ]
        return (<DetalleDemoraPorVolcadora
          fecha={fecha}
          volcadora={volcadora}
          filtroInicial={filtroInicial}
        />)
      }
    }
  },
  {
    name: 'entry',
    label: '1',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['12']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 1
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '2',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['23']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 2
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '3',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['34']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 3
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '4',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['45']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 4
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '5',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['56']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 5
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '6',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['67']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 6
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '7',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['78']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 7
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '8',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['89']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 8
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '9',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['910']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 9
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '10',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['1011']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 10
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '11',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['1112']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 11
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '12',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['1213']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 12
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '13',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['1314']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 13
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '14',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['1415']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 14
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '15',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['1516']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 15
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '16',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['1617']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 16
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '17',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['1718']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 17
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '18',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['1819']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 18
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '19',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['1920']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 19
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '20',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['2021']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 20
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '21',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['2122']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 21
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '22',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['2223']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 22
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '23',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['230']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 23
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'entry',
    label: '0',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: entry => {
        const cantidad = entry['01']
        const demorasPorHora = entry['demoras'].filter((d) => {
          return (moment(d.inicioDeDemora).hours()) === 0
        })
        const value = cantidad > 0 ? cantidad : '-'
        return <DemorasPorHoraEnVolcadora
          demorasPorHora={demorasPorHora}
          value={value}
        />
      }
    }
  },
  {
    name: 'total',
    label: 'Total',
    options: {
      filter: false,
      sort: true,
      stickyRight: true,
      setCellProps: () => ({
        style: {
          position: 'sticky',
          right: 0,
          zIndex: 100,
          backgroundColor: '#dfdfdf'
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          position: 'sticky',
          right: 0,
          background: 'white',
          zIndex: 101
        }
      }),
      customBodyRender: total => {
        return <b>{total}</b>
      },
      total: true
    }
  }
]

export const COLUMNS_HISTOGRAMA_INGRESO_POR_CEREAL = [
  {
    name: 'fecha',
    label: 'Fecha',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      sticky: true,
      customBodyRender: fecha => {
        const f = moment(fecha).format('DD-MM')
        return <>{f}</>
      },
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      sticky: true,
      filterType: 'checkbox',
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: '12',
    label: '1',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '23',
    label: '2',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '34',
    label: '3',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '45',
    label: '4',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '56',
    label: '5',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '67',
    label: '6',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '78',
    label: '7',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '89',
    label: '8',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '910',
    label: '9',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1011',
    label: '10',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1112',
    label: '11',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1213',
    label: '12',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1314',
    label: '13',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1415',
    label: '14',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1516',
    label: '15',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1617',
    label: '16',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1718',
    label: '17',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1819',
    label: '18',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1920',
    label: '19',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '2021',
    label: '20',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '2122',
    label: '21',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '2223',
    label: '22',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '230',
    label: '23',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '01',
    label: '0',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: 'total',
    label: 'Total',
    options: {
      filter: false,
      sort: true,
      stickyRight: true,
      setCellProps: () => ({
        style: {
          position: 'sticky',
          right: 0,
          zIndex: 100,
          backgroundColor: '#dfdfdf'
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          position: 'sticky',
          right: 0,
          background: 'white',
          zIndex: 101
        }
      }),
      customBodyRender: total => {
        return <b>{total}</b>
      },
      total: true
    }
  }
]

export const COLUMNS_HISTOGRAMA_INGRESO_POR_USUARIO = [
  {
    name: 'fecha',
    label: 'Fecha',
    options: {
      filter: true,
      sort: true,
      sticky: true,
      filterType: 'multiselect',
      customBodyRender: fecha => {
        const f = moment(fecha).format('DD-MM')
        return <>{f}</>
      },
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: 'usuarioIngreso',
    label: 'Usuario',
    options: {
      filter: true,
      sort: true,
      sticky: true,
      filterType: 'checkbox',
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: '12',
    label: '1',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '23',
    label: '2',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '34',
    label: '3',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '45',
    label: '4',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '56',
    label: '5',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '67',
    label: '6',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '78',
    label: '7',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '89',
    label: '8',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '910',
    label: '9',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1011',
    label: '10',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1112',
    label: '11',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1213',
    label: '12',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1314',
    label: '13',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1415',
    label: '14',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1516',
    label: '15',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1617',
    label: '16',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1718',
    label: '17',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1819',
    label: '18',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1920',
    label: '19',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '2021',
    label: '20',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '2122',
    label: '21',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '2223',
    label: '22',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '230',
    label: '23',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '01',
    label: '0',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: 'total',
    label: 'Total',
    options: {
      filter: false,
      sort: true,
      stickyRight: true,
      setCellProps: () => ({
        style: {
          position: 'sticky',
          right: 0,
          zIndex: 100,
          backgroundColor: '#dfdfdf'
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          position: 'sticky',
          right: 0,
          background: 'white',
          zIndex: 101
        }
      }),
      customBodyRender: total => {
        return <b>{total}</b>
      },
      total: true
    }
  }
]

export const COLUMNS_HISTOGRAMA_CALADO_POR_PUESTO = [
  {
    name: 'fecha',
    label: 'Fecha',
    options: {
      filter: true,
      sort: true,
      sticky: true,
      filterType: 'multiselect',
      customBodyRender: fecha => {
        const f = moment(fecha).format('DD-MM')
        return <>{f}</>
      },
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: 'puestoDeCalado',
    label: 'Puesto',
    options: {
      filter: true,
      sort: true,
      sticky: true,
      filterType: 'checkbox',
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      }),
      customBodyRender: puesto => {
        const calle = (puesto === 'calle_1-2') ? '1/2' : '3/4'
        return <>{calle}</>
      }
    }
  },
  {
    name: '12',
    label: '1',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '23',
    label: '2',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '34',
    label: '3',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '45',
    label: '4',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '56',
    label: '5',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '67',
    label: '6',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '78',
    label: '7',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '89',
    label: '8',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '910',
    label: '9',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1011',
    label: '10',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1112',
    label: '11',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1213',
    label: '12',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1314',
    label: '13',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1415',
    label: '14',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1516',
    label: '15',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1617',
    label: '16',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1718',
    label: '17',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1819',
    label: '18',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '1920',
    label: '19',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '2021',
    label: '20',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '2122',
    label: '21',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '2223',
    label: '22',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '230',
    label: '23',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: '01',
    label: '0',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      },
      total: true
    }
  },
  {
    name: 'total',
    label: 'Total',
    options: {
      filter: false,
      sort: true,
      stickyRight: true,
      setCellProps: () => ({
        style: {
          position: 'sticky',
          right: 0,
          zIndex: 100,
          backgroundColor: '#dfdfdf'
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          position: 'sticky',
          right: 0,
          background: 'white',
          zIndex: 101
        }
      }),
      customBodyRender: total => {
        return <b>{total}</b>
      },
      total: true
    }
  }
]

export const COLUMNS_HISTOGRAMA_BALANZAS = [
  {
    name: 'fecha',
    label: 'Fecha',
    options: {
      filter: true,
      sort: true,
      sticky: true,
      filterType: 'multiselect',
      customBodyRender: fecha => {
        const f = moment(fecha).format('DD-MM')
        return <>{f}</>
      },
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: 'balanza',
    label: 'Balanza',
    options: {
      filter: true,
      sort: true,
      sticky: true,
      filterType: 'checkbox',
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: '12',
    label: '1',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '23',
    label: '2',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '34',
    label: '3',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '45',
    label: '4',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '56',
    label: '5',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '67',
    label: '6',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '78',
    label: '7',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '89',
    label: '8',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '910',
    label: '9',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '1011',
    label: '10',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '1112',
    label: '11',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '1213',
    label: '12',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '1314',
    label: '13',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '1415',
    label: '14',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '1516',
    label: '15',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '1617',
    label: '16',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '1718',
    label: '17',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '1819',
    label: '18',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '1920',
    label: '19',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '2021',
    label: '20',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '2122',
    label: '21',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '2223',
    label: '22',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '230',
    label: '23',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: '01',
    label: '0',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        const valor = cantidad > 0 ? cantidad : '-'
        return <>{valor}</>
      }
    }
  },
  {
    name: 'total',
    label: 'Total',
    options: {
      filter: false,
      sort: true,
      stickyRight: true,
      setCellProps: () => ({
        style: {
          position: 'sticky',
          right: 0,
          zIndex: 100,
          backgroundColor: '#dfdfdf'
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          position: 'sticky',
          right: 0,
          background: 'white',
          zIndex: 101
        }
      }),
      customBodyRender: total => {
        return <b>{total}</b>
      }
    }
  }
]
